import { Suspense, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';
import { Id, toast } from 'react-toastify';
import useNetworkStatus from 'hooks/useNetworkStatus';
import { Box } from '@mui/material';
import UnderConstruction from 'pages/Maintenance/UnderConstruction';
import { throwSuccessToast } from 'utils';
import { errorMessages, successMessages } from 'constants/messages';
import { IS_UNDER_CONSTRUCTION } from 'config';

const LoaderWrapper = styled('div')(({ theme }) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 2001,
    width: '100%',
    '& > * + *': {
        marginTop: theme.spacing(2),
    },
}));

const Loader = () => (
    <LoaderWrapper>
        <LinearProgress color='primary' />
    </LoaderWrapper>
);

const CommonLayout = ({ layout = 'blank' }: { layout?: string }) => {
    const isUnderConstruction = IS_UNDER_CONSTRUCTION;
    const isOnline = useNetworkStatus();
    const [wasOffline, setWasOffline] = useState(false);

    const [toastId, setToastId] = useState<Id | undefined>(undefined);

    useEffect(() => {
        if (!isOnline) {
            if (!toastId) {
                const id = toast.error(errorMessages.offline, {
                    autoClose: false,
                    closeOnClick: false,
                    draggable: false,
                    position: toast.POSITION.TOP_CENTER,
                    closeButton: false,
                    theme: 'colored',
                });
                setToastId(id);
            }
            setWasOffline(true);
        } else if (wasOffline) {
            toast.dismiss(toastId);
            setToastId(undefined);
            throwSuccessToast({ message: successMessages.backOnline });
            setWasOffline(false);
        }
    }, [isOnline, wasOffline, toastId]);

    return isUnderConstruction ? (
        <UnderConstruction />
    ) : (
        <Box sx={{ opacity: !isOnline ? 0.5 : 1, pointerEvents: !isOnline ? 'none' : 'auto' }}>
            {(layout === 'landing' || layout === 'simple') && (
                <Suspense fallback={<Loader />}>
                    <Outlet />
                </Suspense>
            )}
            {layout === 'blank' && <Outlet />}
        </Box>
    );
};

export default CommonLayout;
